<template>
  <form
    @submit.prevent="handleSubmitAttempt">

    <fieldset class="characteristic-options">
      <legend class="sr-only">Characteristic Options</legend>
      <ChipsInput
        :items="characteristicOptions"
        :selected-options="selectedCharacteristics"
        @input="selected => $emit('updatedSelectedCharacteristics', selected)" >
        <template v-slot:checked-icon>
          <span class="material-icons-outlined select-icon">done</span>
        </template>
      </ChipsInput>
    </fieldset>
    <div class="action-buttons">
      <button
        type="submit"
        :class="['btn', 'btn-lg', 'ai-bg', 'submit', {'cursor-not-allowed': !hasCurrentSelection}]">
        Generate Strategies
      </button>
      <button
        type="button"
        v-if="hasCurrentSelection"
        tabindex="0"
        @click="$emit('clearSelections')"
        @keyup.enter="$emit('clearSelections')"
        class="link-button">
        Clear selections
      </button>
      <span
        class="make-selection-message"
        role="alert"
        v-else-if="triedNoSelectionSubmit">
        Please make at least one selection above.
      </span>
    </div>
  </form>
</template>

<script>
import ChipsInput from '@/components/ChipsInput.vue'

export default {
  name: 'CharacteristicsForm',
  components: { ChipsInput },
  props: {
    characteristicOptions: {
      type: Array,
      default() {
        return []
      }
    },
    selectedCharacteristics: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      triedNoSelectionSubmit: false
    }
  },
  computed: {
    hasCurrentSelection() {
      return this.selectedCharacteristics?.length
    },
  },
  methods: {
    handleSubmitAttempt() {
      if (!this.hasCurrentSelection) {
        this.triedNoSelectionSubmit = true
      } else {
        this.$emit('submit')
      }
    }
  },
  watch: {
    hasCurrentSelection(newValue) {
      if (newValue) {
        this.triedNoSelectionSubmit = false
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import "~@/variables.less";
@import "~@/globalstyles.less";

p, legend {
  font-size: 1rem;
}
legend {
  border: none;
  margin-bottom: 0.25rem;
}
/deep/ .checkboxes-container {
  padding-top: 0;
}
/deep/ .checkbox-item {
  margin: 0.25rem 0.5rem 0.25rem 0;
  padding: 0;

  label {
    border-radius: 0.5rem;
    padding: 0.5rem 1.5rem;
    font-size: 0.875rem;
    background-color: #F1F1F1;
    border: 1px solid transparent;

    span {
      font-weight: bold;
      color: #803DCB;
    }

    &:hover {
      background-color: #e6e6e6;
    }

    &:focus {
      outline: 0.125rem solid @gray-dark;
      outline-offset: 0.125rem;
    }
  }
  label.selected {
    font-weight: normal;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    color: @gray-dark;
    background: var(--blue-weak);
    border: 1px solid var(--blue-default);
    border-radius: var(--radius-large);

    span {
      color: white;
    }

    .select-icon {
      color: var(--blue-default);
      width: 1rem;
    }
  }
}
.action-buttons {
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  font-size: 0.875rem;

  .link-button, .make-selection-message {
    padding: 0;
  }
}
.submit {
  color: white;
  margin-right: 1.5rem;
  font-weight: normal;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: var(--radius-base);
  background: var(--AI-AI-Blue-Pink);

  &:hover, &:active {
    background: var(--AI-AI-Blue-Pink-Hover);
  }

  &:focus {
    outline: 2px solid var(--blue-hover);
    outline-offset: 2px;
  }

  .ai-logo {
    height: 2.25em;
  }
}
.characteristic-options {
  margin-bottom: 1.75rem;
}

.make-selection-message {
  font-size: 0.875rem;
}

/* fade transition */
.sd-list-enter-active,
.sd-list-leave-active {
  transition: opacity 0.5s;
}
.sd-list-enter,
.sd-list-leave-to {
  opacity: 0;
}
</style>
